import type { DiagnosticsReportResponse } from './api/diagnosticsReportApi';

export type DiagnosticsReportProgressEvent = {
  type: 'progress';
  progress: number;
  url: string;
  checks: Partial<Record<string, boolean>>;
};

export type DiagnosticsReportCompleteEvent = {
  type: 'complete';
  url: string;
  userAgents?: DiagnosticsReportResponse['userAgents'];
  reportId?: string;
};

export type DiagnosticsReportErrorEvent = {
  type: 'error';
  url: string;
  message: string;
};

export type DiagnosticsReportEvent =
  | DiagnosticsReportProgressEvent
  | DiagnosticsReportCompleteEvent
  | DiagnosticsReportErrorEvent;

export type DiagnosticsState = {
  loading: boolean;
  hasDiagnosticsRun: boolean;
  diagnosticsError?: string;
  diagnosticsChecks: Partial<Record<string, boolean>>;
  domain: string;
  reportId?: string;
  crawlers?: string[];
};

// Router location state passed by the report page's "Rerun diagnostics"
// button so the diagnostics tab starts the run on arrival (PRE-3136).
export type DiagnosticsRerunLocationState = {
  rerunDiagnostics?: {
    domain: string;
    requestId: string;
  };
};

export const INITIAL_DIAGNOSTICS_STATE: DiagnosticsState = {
  loading: false,
  hasDiagnosticsRun: false,
  diagnosticsChecks: {},
  diagnosticsError: undefined,
  domain: '',
  reportId: undefined,
  crawlers: undefined,
};
